import React, { useState } from "react";
import { UserPlus } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const PortalAccessButton = ({ owner, onDone }) => {
  const [busy, setBusy] = useState(false);
  if (!owner.email) {
    return <span data-testid={`portal-access-noemail-${owner.id}`} className="text-[0.7rem] text-muted-foreground px-2">Add an email first</span>;
  }
  const give = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      const { data } = await api.post(`/landlords/${owner.id}/portal-access`);
      if (data.emailed) toast.success(`Portal invite emailed to ${data.email}`);
      else toast.warning(`Login created, but the invite email to ${data.email} couldn't be sent. Use Reset password to resend.`);
      onDone();
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <Button variant="ghost" size="sm" className="h-8 text-xs" data-testid={`portal-access-${owner.id}`} onClick={give} disabled={busy}>
      <UserPlus className="h-3.5 w-3.5 mr-1" />{busy ? "Sending…" : "Give portal access"}
    </Button>
  );
};
